export const estimateResponseTime = (walletToRegister = {}) => {
  let estimatedResponseTime = 200; // base response time;
  if (!walletToRegister.isSetupComplete) {
    estimatedResponseTime += 10000;
  }

  walletToRegister.newLabelProviderIds?.forEach(() => {
    estimatedResponseTime += 200;
  });

  return estimatedResponseTime;
};
